module.exports = __webpack_public_path__ + "static/media/60B2EE.ed5468b6.svg";